import { Form, message, Modal } from 'antd';
import BKButton from 'components/BKButton';
import BKInput from 'components/BKInput';
import BKModal from 'components/BKModal';
import React, { useState } from 'react';
import authService from 'services/authService';

const ChangePasswordModal = ({ open, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const handleChangePassword = async (values) => {
    setLoading(true);
    try {
      const payload = {
        password: values.currentPassword,
        new_password: values.newPassword,
        confirmed_new_password: values.confirmNewPassword
      };

      await authService.changePassword(payload);
      message.success('Đổi mật khẩu thành công');
      form.resetFields();
      onClose();

      setTimeout(() => {
        window.location.href = '/thoat';
      }, 1000);
    } catch (error) {
      const fieldError = error.field;
      const errorMessage = error.message || 'Đổi mật khẩu thất bại';

      if (fieldError === 'password') {
        form.setFields([
          {
            name: 'currentPassword',
            errors: [errorMessage]
          }
        ]);
        setIsFormValid(false);
      } else {
        message.error(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    Modal.confirm({
      title: 'Xác nhận đổi mật khẩu',
      content: 'Bạn có chắc chắn muốn đổi mật khẩu không?',
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      okType: 'danger',
      onOk() {
        handleChangePassword(values);
      }
    });
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleSubmit = () => {
    form.submit();
  };

  const handleFormChange = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
    const allFieldsTouched = form.isFieldsTouched(
      ['currentPassword', 'newPassword', 'confirmNewPassword'],
      true
    );
    setIsFormValid(!hasErrors && allFieldsTouched);
  };

  return (
    <div>
      <BKModal
        open={open}
        onClose={onClose}
        title="Đổi mật khẩu"
        footer={
          <>
            <BKButton variant="secondary" onClick={onClose}>
              Hủy
            </BKButton>
            <BKButton
              onClick={handleSubmit}
              loading={loading}
              disabled={!isFormValid || loading}>
              Đổi mật khẩu
            </BKButton>
          </>
        }
        children={
          <Form
            form={form}
            name="change-password"
            layout="vertical"
            labelCol={{ span: 8 }}
            onFinish={onFinish}
            onFieldsChange={handleFormChange}
            autoComplete="off"
            onFinishFailed={onFinishFailed}>
            <Form.Item
              label="Mật khẩu hiện tại"
              name="currentPassword"
              rules={[
                {
                  required: true,
                  message: 'Vui lòng nhập mật khẩu hiện tại!'
                }
              ]}>
              <BKInput type="password" placeholder="Nhập mật khẩu hiện tại" />
            </Form.Item>
            <Form.Item
              label="Mật khẩu mới"
              name="newPassword"
              rules={[
                { required: true, message: 'Vui lòng nhập mật khẩu mới!' }
              ]}>
              <BKInput type="password" placeholder="Nhập mật khẩu mới" />
            </Form.Item>
            <Form.Item
              label="Xác nhận mật khẩu mới"
              name="confirmNewPassword"
              dependencies={['newPassword']}
              rules={[
                {
                  required: true,
                  message: 'Vui lòng xác nhận mật khẩu mới!'
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error('Hai mật khẩu bạn nhập không khớp!')
                    );
                  }
                })
              ]}>
              <BKInput type="password" placeholder="Xác nhận mật khẩu mới" />
            </Form.Item>
          </Form>
        }
      />
    </div>
  );
};

export default ChangePasswordModal;
